/**
 * Category icon assets for the guest map chip strip.
 *
 * The icons are bespoke clay-style 3D PNGs (transparent alpha) generated
 * for the app and stored under `/public/category-icons-3d/`. Keeping the
 * slug -> URL map here lets the chip strip stay small while the taxonomy
 * in `venueCategories.js` remains framework-agnostic.
 */

const ICON_BASE = '/category-icons-3d';

export const CATEGORY_ICON_URLS = {
  'breakfast-coffee': `${ICON_BASE}/breakfast-coffee.png`,
  brunch: `${ICON_BASE}/brunch.png`,
  'street-food': `${ICON_BASE}/street-food.png`,
  grill: `${ICON_BASE}/grill.png`,
  'fine-dining': `${ICON_BASE}/fine-dining.png`,
  'cocktails-bars': `${ICON_BASE}/cocktails-bars.png`,
  'wine-bars': `${ICON_BASE}/wine-bars.png`,
  mediterranean: `${ICON_BASE}/mediterranean.png`,
  italian: `${ICON_BASE}/italian.png`,
  indian: `${ICON_BASE}/indian.png`,
  asian: `${ICON_BASE}/asian.png`,
  mexican: `${ICON_BASE}/mexican.png`,
  'comfort-food': `${ICON_BASE}/comfort-food.png`,
  desserts: `${ICON_BASE}/desserts.png`,
  'vegetarian-vegan': `${ICON_BASE}/vegetarian-vegan.png`,
};

export function getCategoryIconUrl(slug) {
  return CATEGORY_ICON_URLS[slug] || null;
}
